import { render, staticRenderFns } from "./ExchangePassportView.vue?vue&type=template&id=26401ea4"
import script from "./ExchangePassportView.vue?vue&type=script&lang=js"
export * from "./ExchangePassportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports